import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "./ui/switch";

const KEY = "kledio_cookie_consent";
export const getConsent = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState(false);
  const [prefs, setPrefs] = useState({ comfort: true, statistics: false });

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const open = () => { const c = getConsent(); if (c) setPrefs({ comfort: !!c.comfort, statistics: !!c.statistics }); setSettings(true); setVisible(true); };
    window.addEventListener("kledio:cookie-settings", open);
    return () => window.removeEventListener("kledio:cookie-settings", open);
  }, []);

  const save = (p) => {
    localStorage.setItem(KEY, JSON.stringify({ ...p, necessary: true, ts: Date.now() }));
    setVisible(false); setSettings(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-end sm:items-center justify-center" role="dialog" aria-modal="true" aria-label="Privatsphäre-Einstellungen" data-testid="cookie-banner">
      <div className="bg-white w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl shadow-2xl max-h-[92vh] overflow-y-auto">
        <div className="p-6 sm:p-7 space-y-4">
          <h2 className="text-xl sm:text-2xl font-bold">Deine Privatsphäre-Einstellungen</h2>
          <p className="text-sm text-foreground/80 leading-relaxed">
            Wir speichern und/oder greifen auf Informationen auf deinem Gerät zu, z. B. auf Cookies oder
            eindeutige Bezeichner, um personenbezogene Daten zu verarbeiten. Du kannst zustimmen oder deine
            Präferenzen verwalten, einschließlich deines Widerspruchsrechts bei berechtigtem Interesse.
            Klicke dazu auf „Cookies verwalten" oder besuche jederzeit unsere{" "}
            <Link to="/datenschutz" onClick={() => { setVisible(false); setSettings(false); }} className="text-accent font-semibold underline underline-offset-2" data-testid="cookie-policy-link">Datenschutzerklärung</Link>.
            Deine Auswahl hat keinen Einfluss auf deine KLEDIO-Erfahrung und kann jederzeit über
            „Cookie-Einstellungen" im Footer geändert werden.
          </p>
          <div>
            <p className="text-sm font-bold">Wir verarbeiten Daten für folgende Zwecke:</p>
            <p className="text-sm text-muted-foreground leading-relaxed mt-1">
              Sicherer Betrieb der Plattform (Anmeldung, Warenkorb-/Kauffunktionen, Betrugsprävention) ·
              Komfortfunktionen wie gemerkte Einstellungen und zuletzt angesehene Artikel ·
              anonymisierte Statistik zur Messung und Verbesserung von Inhalten und Angeboten.
            </p>
          </div>
          {settings && (
            <div className="space-y-3 border border-border rounded-xl p-4" data-testid="cookie-settings-panel">
              <div className="flex items-center justify-between gap-3">
                <div><p className="text-sm font-semibold">Notwendig</p><p className="text-xs text-muted-foreground">Für Betrieb, Sicherheit und Login erforderlich</p></div>
                <Switch checked disabled />
              </div>
              <div className="flex items-center justify-between gap-3">
                <div><p className="text-sm font-semibold">Komfort</p><p className="text-xs text-muted-foreground">Merkt sich Einstellungen und Ansichten</p></div>
                <Switch data-testid="cookie-comfort-switch" checked={prefs.comfort} onCheckedChange={(v) => setPrefs({ ...prefs, comfort: v })} />
              </div>
              <div className="flex items-center justify-between gap-3">
                <div><p className="text-sm font-semibold">Statistik</p><p className="text-xs text-muted-foreground">Anonyme Nutzungsstatistiken zur Verbesserung</p></div>
                <Switch data-testid="cookie-stats-switch" checked={prefs.statistics} onCheckedChange={(v) => setPrefs({ ...prefs, statistics: v })} />
              </div>
            </div>
          )}
          <div className="space-y-2.5 pt-1">
            <button data-testid="cookie-accept-all" onClick={() => save({ comfort: true, statistics: true })}
              className="w-full bg-accent text-white text-sm font-bold py-3.5 rounded-full hover:opacity-90 active:scale-[0.99] transition-transform">
              Alle zulassen
            </button>
            <button data-testid="cookie-necessary-only" onClick={() => save({ comfort: false, statistics: false })}
              className="w-full border-2 border-foreground/80 text-sm font-bold py-3 rounded-full hover:bg-secondary">
              Nur notwendige auswählen
            </button>
            {settings ? (
              <button data-testid="cookie-save-prefs" onClick={() => save(prefs)}
                className="w-full text-accent text-sm font-bold py-2 hover:underline">Auswahl speichern</button>
            ) : (
              <button data-testid="cookie-open-settings" onClick={() => setSettings(true)}
                className="w-full text-accent text-sm font-bold py-2 hover:underline">Cookies verwalten</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
